import React from 'react';
import { ListGroup, Dropdown } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
import avatar1 from '../../../../assets/images/user/avatar-1.jpg';

import useWindowSize from '../../../../hooks/useWindowSize';
import NavSearch from './NavSearch';
import { Typography } from '@mui/material';
// import NavSearch from './NavSearch';

const NavLeft = () => {
  const windowSize = useWindowSize();

  let dropdownAlign = 'start';

  let navItemClass = ['nav-item'];
  if (windowSize.width <= 575) {
    navItemClass = [...navItemClass, 'd-none'];
  }

  return (
    <React.Fragment>
      <ListGroup as="ul" bsPrefix=" " className="navbar-nav mr-auto">
        <ListGroup.Item as="li" bsPrefix=" " className={navItemClass.join(' ')}>
          <div className='d-flex' style={{display:"flex",flex:1,flexDirection:"row"}}>
            <Typography variant="h6" color="textSecondary">
              Welcome GlagAdmin
            </Typography>
            {/* <img src={avatar1} className="img-radius" style={{width:50 , height:50 , marginTop:7 , marginLeft:5}} alt="User Profile" /> */}
          </div>
          {/* <Dropdown align={dropdownAlign}>
            <Dropdown.Toggle variant={'link'} id="dropdown-basic">
              Dropdown
            </Dropdown.Toggle>
            <ul>
              <Dropdown.Menu>
                <li>
                  <Link to="#" className="dropdown-item">
                    Action
                  </Link>
                </li>
                <li>
                  <Link to="#" className="dropdown-item">
                    Another action
                  </Link>
                </li>
                <li>
                  <Link to="#" className="dropdown-item">
                    Something else here
                  </Link>
                </li>
              </Dropdown.Menu>
            </ul>
          </Dropdown> */}
        </ListGroup.Item>
        {/* <ListGroup.Item as="li" bsPrefix=" " className="nav-item">
          <NavSearch windowWidth={windowSize.width} />
        </ListGroup.Item> */}
      </ListGroup>
    </React.Fragment>
  );
};

export default NavLeft;
